<div class="auth-shell">
  <aside class="auth-sidebar" [attr.aria-label]="'auth.layout.sidebarAriaLabel' | translate">
    <header class="brand-row">
      <app-icon icon="logo-safegpt-brand.svg" [width]="50" [height]="50" [alt]="'auth.layout.brandAlt' | translate" />
      <span class="brand-name">{{ 'app.name' | translate }}</span>
    </header>

    <section class="intro-block" aria-labelledby="auth-layout-heading">
      <h1 id="auth-layout-heading" class="intro-title">
        <span>{{ 'auth.layout.hero.line1' | translate }}</span>
        <span>{{ 'auth.layout.hero.line2Prefix' | translate }} <strong>{{ 'app.name' | translate }}</strong></span>
      </h1>
      <p class="intro-copy">
        {{ 'auth.layout.hero.copyLine1' | translate }}
        <br />
        {{ 'auth.layout.hero.copyLine2' | translate }}
        <br />
        {{ 'auth.layout.hero.copyLine3' | translate }}
      </p>
    </section>

    <section class="feature-list" [attr.aria-label]="'auth.layout.featuresAriaLabel' | translate">
      @for (feature of featureCards; track feature.titleKey) {
      <article class="feature-item">
        <div class="feature-icon-box" aria-hidden="true">
          <app-icon [icon]="feature.icon" [width]="feature.width" [height]="feature.height" aria-hidden="true"
            color="currentColor" />
        </div>
        <div class="feature-content">
          <span class="feature-title">{{ feature.titleKey | translate }}</span>
          <p class="feature-text">
            {{ feature.textTopKey | translate }}
            <br />
            {{ feature.textBottomKey | translate }}
          </p>
        </div>
      </article>
      }
    </section>

    <footer class="sidebar-footer">
      <app-icon icon="icon-shield-solid.svg" [width]="30" [height]="30" aria-hidden="true" />
      <div>
        <p class="footer-title">{{ 'auth.layout.footer.title' | translate }}</p>
        <p class="footer-copy">{{ 'auth.layout.footer.copy' | translate }}</p>
      </div>
    </footer>

    <app-auth-language-switcher class="auth-sidebar-language-switcher" />
  </aside>

  <main class="auth-content" id="auth-content" tabindex="-1">
    <div class="auth-mobile-language-switcher">
      <app-auth-language-switcher />
    </div>
    <router-outlet />
  </main>
</div>
